import { HttpBackend, HttpClient, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { AuthHelperService } from '../helpers/auth-helper.service';
import { AuthenticationService } from '../service';

@Injectable({
    providedIn: 'root'
})
export class ConfirmInvitationApiService {

    private httpClient: HttpClient;

    constructor(httpClientHandler: HttpBackend, private _authenticationService: AuthenticationService, private httpXsrfTokenExtractor: HttpXsrfTokenExtractor, private authHelperService: AuthHelperService) {

        this.httpClient = new HttpClient(httpClientHandler); // Create a new instance of HttpClient as BE send complete url (with domain) and we have to bypass the default interceptors
    }

    getConfirmationSettings(apiUrl: string) {
        return this.httpClient.get(apiUrl, {
            withCredentials: false, headers: {
                'accept': `application/json`,
            }
        });
    }
}
